export default __webpack_public_path__ + "static/media/finishedCircle.7197e268.png";